import React,{useEffect,useRef,useState} from 'react';
import {useGuest} from '../services/GuestContext';
import {guestRequest} from '../services/guestApi';
import {BadgeDefinition} from '../services/badgeApi';
import {Button} from './ui';

export default function WelcomePatchSettings({patches,disabled,onDirtyChange}:{patches:BadgeDefinition[];disabled:boolean;onDirtyChange:(dirty:boolean)=>void}){
 const {farm,refresh,offline}=useGuest();
 const [selected,setSelected]=useState(farm?.welcome_patch_id||''),[baseline,setBaseline]=useState(farm?.welcome_patch_id||'');
 const [busy,setBusy]=useState(false),[error,setError]=useState(''),[message,setMessage]=useState('');
 const dirty=selected!==baseline,dirtyRef=useRef(dirty);dirtyRef.current=dirty;
 const currentFarm=useRef(farm?.farm_id);currentFarm.current=farm?.farm_id;
 useEffect(()=>{if(!dirtyRef.current){setSelected(farm?.welcome_patch_id||'');setBaseline(farm?.welcome_patch_id||'');}},[farm?.welcome_patch_id]);
 useEffect(()=>{onDirtyChange(dirty);},[dirty,onDirtyChange]);
 useEffect(()=>()=>onDirtyChange(false),[onDirtyChange]);
 if(!farm)return null;
 const eligible=patches.filter(patch=>patch.status==='published'&&patch.rule?.type==='manual'&&!patch.progression_levels);
 const save=async()=>{
  const farmId=farm.farm_id,value=selected;
  setBusy(true);setError('');setMessage('');
  try{
   await guestRequest('/guest/welcome/'+encodeURIComponent(farmId),'PUT',{welcome_patch_id:value||null});
   if(currentFarm.current!==farmId)return;
   setBaseline(value);setMessage('Welcome Patch saved.');await refresh();
  }catch(err){if(currentFarm.current===farmId)setError((err as Error).message);}
  finally{if(currentFarm.current===farmId)setBusy(false);}
 };
 return <section className="border rounded-2xl p-5 bg-white space-y-4">
  <h3 className="font-medium">New-user welcome Patch</h3>
  <p className="text-sm text-gray-600">Awarded once when a new member first opens the app. Choose a published, single-level Patch with Admin awards only. Edit its artwork and story in the Patch catalogue above.</p>
  <label className="block text-sm font-medium">Welcome Patch<select disabled={disabled||busy||offline} value={selected} onChange={event=>{setSelected(event.target.value);setMessage('');}} className="block w-full border rounded-lg p-3 mt-2">
   <option value="">Choose a welcome Patch</option>
   {selected&&!eligible.some(patch=>patch.badge_id===selected)&&<option value={selected}>Current Patch unavailable · choose a replacement</option>}
   {eligible.map(patch=><option key={patch.badge_id} value={patch.badge_id}>{patch.name}</option>)}
  </select></label>
  <p className="text-xs text-gray-500">A valid welcome Patch is required before generating invitations.</p>
  {error&&<p role="alert" className="text-red-700 text-sm">{error}</p>}{message&&<p role="status" className="text-usda-700 text-sm">{message}</p>}
  <Button disabled={disabled||busy||offline||!dirty} onClick={()=>void save()}>{busy?'Saving…':'Save welcome Patch'}</Button>
 </section>;
}
